interface ImageSlotProps {
  label?: string;
  hint?: string;
  icon?: string;
  tone?: "light" | "dark";
  className?: string;
}

export default function ImageSlot({
  label = "Prostor za fotografijo",
  hint,
  icon = "ri-image-line",
  tone = "light",
  className = "",
}: ImageSlotProps) {
  const isDark = tone === "dark";

  return (
    <div
      className={`relative flex h-full w-full flex-col items-center justify-center gap-3 overflow-hidden ${
        isDark
          ? "bg-gradient-to-br from-primary-900 via-primary-950 to-primary-900"
          : "bg-gradient-to-br from-background-100 via-background-200/70 to-background-200"
      } ${className}`}
    >
      <div
        className={`pointer-events-none absolute inset-3 rounded-md border ${
          isDark ? "border-background-50/15" : "border-background-300/70"
        }`}
      />

      <span
        className={`relative flex h-10 w-10 items-center justify-center rounded-full ${
          isDark
            ? "bg-background-50/10 text-background-100/70"
            : "bg-background-50 text-foreground-400"
        }`}
      >
        <i className={`${icon} text-base`} />
      </span>

      <p
        className={`relative px-6 text-center font-label text-[9px] font-semibold uppercase tracking-[0.22em] ${
          isDark ? "text-background-100/65" : "text-foreground-500"
        }`}
      >
        {label}
      </p>

      {hint && (
        <p
          className={`relative px-6 text-center text-[11px] leading-relaxed ${
            isDark ? "text-background-100/40" : "text-foreground-400"
          }`}
        >
          {hint}
        </p>
      )}
    </div>
  );
}